import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';


import dataIndustryQuestioned from "../../data/discussion.json";
import getBaitToPlateSupplyChain from "../../utilities/getBaitToPlateSupplyChain";
import getUbiquitySupplyChain from "../../utilities/getUbiquitySupplyChain";
import getDiscussionEntityFlagsFromSupplyChain from "../../utilities/getDiscussionEntityFlagsFromSupplyChain";
import dataFlags from "../../data/bait-to-plate/data-flags-combined.json";
import { withPrefix } from 'gatsby';
import cookie from '../../utilities/cookie';


const supplyChainFullIndexItemsCombined = getBaitToPlateSupplyChain();
const getSupplyChainMatchesBySlugs = (slugs) => {
  const matches = supplyChainFullIndexItemsCombined.filter(item => slugs.includes(item.slug) || ( item.old_slug && slugs.includes(item.old_slug) ));
  return matches;
}

const ubiquitySupplyCahinFullIndexItemsCombined = getUbiquitySupplyChain();
const getUbiquitySupplyChainMatchesBySlugs = (slugs) => {
  const matches = ubiquitySupplyCahinFullIndexItemsCombined.filter(item => slugs.includes(item.slug));
  return matches;
}

const allIndustryQuestionedWithFlags = dataIndustryQuestioned.map(item => {

  const supplyChainMatches = getSupplyChainMatchesBySlugs(item.b2p_slugs);
  const ubiquitySupplyChainMatches = getUbiquitySupplyChainMatchesBySlugs(item.ubiquity_slugs);

  const { flags, processor_flags, vessel_flags } = getDiscussionEntityFlagsFromSupplyChain(item, supplyChainMatches, ubiquitySupplyChainMatches);

  
  item.flags = flags;
  item.processor_flags = processor_flags;
  item.vessel_flags = vessel_flags;
  item.supplyChainMatches = supplyChainMatches;
  item.ubiquitySupplyChainMatches = ubiquitySupplyChainMatches;

  return item;
});


const DiscussionContext = createContext();

function useDiscussion() {
  return useContext(DiscussionContext);
}

const DiscussionProvider = ({ children, itemToLoad }) => {
  

  const foundItemToLoad = allIndustryQuestionedWithFlags.find((item) => item.slug === itemToLoad);

  const [entities, setEntities] = useState(allIndustryQuestionedWithFlags);
  const [entity, setEntity] = useState(foundItemToLoad || null);

  const [encodedFilters, setEncodedFilters] = useState(null);

  useEffect(() => {
    if ( encodedFilters === null ) {
      setEncodedFilters("");
    }
  }, [encodedFilters])

  

  /*useEffect(() => {
    if (typeof window !== 'undefined') {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      const filters = params.get('filters');
      setEncodedFilters(filters);
    }
  }, []);*/

  useEffect(() => {
    // Assuming you're on /your-path and just want to add query params
    if (typeof window !== "undefined" && encodedFilters ) {
      const currentUrl = window.location.pathname + window.location.search;
      const newUrl = `${window.location.pathname}?${encodedFilters}`;
      if ( currentUrl !== newUrl ) {
       window.history.pushState({}, '', newUrl);
       //cookie("ooChinaDiscussionFilters", encodedFilters, 1);
      }
    }
  }, [encodedFilters]);

  function entityHasFlag(entity, flag) {
    if ( flag === "uyghur-labor" || flag === "north-korean-labor" ) {
      
      return entity?.flags?.includes(flag) || entity?.processor_flags?.includes(flag);
    }
    else if ( flag === "human-rights" ) {
      return entity?.vessel_flags?.filter((vesselFlag) => dataFlags.find((dataFlag) => dataFlag.slug === vesselFlag)?.is_human_rights_concern).length > 0 || entity?.flags?.includes(flag) || entity?.processor_flags?.includes(flag);
    }
    else if ( flag === "environmental" ) {
      return entity?.vessel_flags?.filter((vesselFlag) => dataFlags.find((dataFlag) => dataFlag.slug === vesselFlag)?.is_environmental_concern).length > 0 || entity?.flags?.includes(flag) || entity?.processor_flags?.includes(flag);
    }
    else if ( flag === "flagging-in" ) {
      return entity?.investigation_slug === "flagging-in";
    }
    else if ( flag === "other" ) {
      return entity?.flags?.length < 1 && entity?.processor_flags?.length < 1 && entity?.vessel_flags?.length < 1;
    }
    else if ( flag === "any" ) {
      return true;
    }
    return false;
  }
  
  const getEntityHash = (entity, includePrefix = true) => {
    let hash = "";
    hash = "/discussion/stakeholders/";
    if ( entity ) {
      /* TK FIX S HERE */
      hash += `${entity.slug}/`;
    }
    if ( includePrefix ) {
      hash = withPrefix(hash);
    }
    /*if ( encodedFilters ) {
      hash += `?${encodedFilters}`;
    }*/
    return hash;
  }
  
  function getEntityTitle(entity) {
    let title = "";
    if ( entity ) {
      title = `${entity.name}`;
    }
    return title;
  }

  // Value to be passed to provider
  const value = useMemo(() => ({
    encodedFilters,
    setEncodedFilters,
    entities,
    setEntities,
    entity,
    setEntity,
    entityHasFlag,
    getEntityHash,
    getEntityTitle
  }), [encodedFilters, setEncodedFilters, entities, setEntities, entity, setEntity]);

  return (
    <DiscussionContext.Provider value={value}>
      {children}
    </DiscussionContext.Provider>
  );
};

export { DiscussionProvider, useDiscussion };
